import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import PostbackPageComponent from '../PostbackPage/PostbackPage.container';
import CheckContent from '../../../CheckContent';
import { I18nContext } from 'utils/I18n/context';

const EditPostbackPage = ({ loading, params, postback, getListPostbacks }) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        loading: loading,
        id: params?.id,
        postback: postback || {}
    });

    useEffect(() => {
        setState(prev => ({
            ...prev,
            loading: loading,
            postback: postback || {}
        }));
    }, [loading, postback]);

    useEffect(() => {
        if (state.id) {
            getListPostbacks(state.id);
        }
    }, [state.id, getListPostbacks]);

    const staticNames = t?.postbackPage?.editing || { 
        title: 'Edit Postback', 
        subtitle: 'Edit Postback' 
    };

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <CheckContent
                    loading={state.loading}
                    isEmpty={!Object.keys(state.postback).length}
                >
                    <div className="ibox postback edit-postback">
                        <div className="ibox-title">
                            <h5>{staticNames.subtitle}</h5>
                        </div>
                        <PostbackPageComponent
                            postback={state.postback}
                        />
                    </div>
                </CheckContent>
            </section>
        </React.Fragment>
    );
};

EditPostbackPage.propTypes = {
    loading: PropTypes.bool,
    params: PropTypes.object,
    postback: PropTypes.object,
    getListPostbacks: PropTypes.func
};

EditPostbackPage.defaultProps = {
    loading: false,
    params: {},
    postback: {},
    getListPostbacks: () => {}
};

export default EditPostbackPage;
